'use client'

// src/api/events/where.ts
var commonWhere = {
  visibility_not: "private"
  // OR: [
  //   { schedule: { closeDateTime_exists: false } },
  //   // Using new Date() alone would be accutare
  //   // but it means the payload body will change every second
  //   // which will kill the cache implementation in CF
  //   { schedule: { closeDateTime_gte: new Date(new Date().setMinutes(0, 0, 0)) } },
  // ],
};

export {
  commonWhere
};
//# sourceMappingURL=chunk-VCKNEC77.mjs.map